import { DateTime } from "luxon"
import get from "lodash/get"
import isEmpty from "lodash/isEmpty"
import RSVPConfig from "RSVPConfig"

const cancelDaysBefore = get(RSVPConfig, "parkingSession.cancelDaysBefore")
const cancelTime = get(RSVPConfig, "parkingSession.cancelTime")
const cancelTimeOptions = get(RSVPConfig, "parkingSession.cancelTimeOptions", [])

// Helper function to select the appropriate cancellation time
// If there are no cancelTimeOptions, use the cancelDaysBefore and cancelTime
// For the Oakwiev portal we have 2 start times and then 2 cancel times (cancelTimeOptions)
export const selectCancelTime = (sessionStartTime, timezone) => {
  if (isEmpty(cancelTimeOptions)) {
    return { cancelDaysBefore, cancelTime }
  }

  const sessionHour = DateTime.fromISO(sessionStartTime).setZone(timezone).hour
  return cancelTimeOptions.find(timeOption => sessionHour < (timeOption.startTimeThreshold || 24)) || cancelTimeOptions[cancelTimeOptions.length - 1]
}

// Calculate the cancellation cutoff time based on session start time and cancelTime and CancelDaysBefore
export const calculateCancelCutoff = (startTime, timezone, cancelTimeToUse) => {
  const [hours, minutes] = cancelTimeToUse.cancelTime.split(":").map(Number)

  return DateTime.fromISO(startTime)
    .setZone(timezone)
    .startOf("day")
    .minus({ days: cancelTimeToUse.cancelDaysBefore })
    .plus({ hours, minutes })
}

// Check if cancellation is currently allowed
export const isCancellationAllowed = (startTime, timezone) => {
  const cancelTimeToUse = selectCancelTime(startTime, timezone)
  const cancelCutoff = calculateCancelCutoff(startTime, timezone, cancelTimeToUse)

  return DateTime.now().setZone(timezone) < cancelCutoff
}
